export default __webpack_public_path__ + "assets/images/dd238c2e9bf4156bcdd35f429cdadf20.jpg";